// Animated "Analysing Data..." graphic for the ad quiz funnel.
// Cycles through the provided brand/logo icons with a staggered pulse.
const ICONS = [
  "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/702aa8305_6.png",
  "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/7f44821d2_4.png",
  "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/fe20c6938_8.png",
  "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/8863511ee_10.png",
];

export default function AdFunnelAnalysing() {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 22 }}>
      <div style={{ display: "flex", gap: 12, alignItems: "center", justifyContent: "center" }}>
        {ICONS.map((src, i) => (
          <div key={i} className="af-icon"
            style={{
              width: 44, height: 44, borderRadius: "50%", overflow: "hidden",
              display: "flex", alignItems: "center", justifyContent: "center",
              animation: `afPulse 1.4s ${i * 0.18}s infinite ease-in-out`,
            }}>
            <img src={src} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          </div>
        ))}
      </div>
      <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, fontWeight: 600, color: "#000", margin: 0, letterSpacing: "-0.01em" }}>
        Analysing Data<span className="af-dots">...</span>
      </p>
      <style>{`
        @keyframes afPulse {
          0%, 100% { transform: scale(0.82); opacity: 0.45; }
          50% { transform: scale(1.14); opacity: 1; }
        }
        @keyframes afDots { 0% { opacity: 0.2; } 50% { opacity: 1; } 100% { opacity: 0.2; } }
        .af-dots { display: inline-block; animation: afDots 1.2s infinite ease-in-out; }
      `}</style>
    </div>
  );
}